module.exports = __webpack_public_path__ + "img/icon-arrow.701d67bd.svg";